import React from 'react';
var SvgInviteMinor = function SvgInviteMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.5 4a1.5 1.5 0 0 0-1.5 1.5v9a1.5 1.5 0 0 0 1.5 1.5h13a1.5 1.5 0 0 0 1.5-1.5v-9a1.5 1.5 0 0 0-1.5-1.5h-13zm2.015 2.143a1 1 0 1 0-1.03 1.714l5 3a1 1 0 0 0 1.03 0l5-3a1 1 0 1 0-1.03-1.714l-4.485 2.69-4.485-2.69z"
  }));
};
export { SvgInviteMinor as S };